import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';
import axiosInterceptor from '../services/axiosInterceptor';

//persist store after refresh
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import watcherSaga from '../sagas/watcherSaga';

const persistConfig = {
	key: 'root',
	storage,
}

// const persistedReducer = persistReducer(persistConfig, rootReducer)

// create the saga middleware
const sagaMiddleware = createSagaMiddleware()

const middleware = [thunk, sagaMiddleware];

const store = createStore(
	rootReducer,
	// persistedReducer,
	composeWithDevTools(applyMiddleware(...middleware)),
);

// localStorage.setItem('allStates', JSON.stringify(store.getState()));
//store avialable on refresh
let persistor = {};
// let persistor = persistStore(store);


//register axios interceptor
axiosInterceptor(store.dispatch);

// then run the saga
sagaMiddleware.run(watcherSaga)

export  {store, persistor};
